/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Specification - Omobility app
 * OpenAPI documentation for Omobility app with Keycloak user authentication
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface FilterCriteriaObject
 */
export interface FilterCriteriaObject {
    /**
     * 
     * @type {string}
     * @memberof FilterCriteriaObject
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof FilterCriteriaObject
     */
    'operation'?: FilterCriteriaObjectOperationEnum;
    /**
     * 
     * @type {object}
     * @memberof FilterCriteriaObject
     */
    'value'?: object;
    /**
     * 
     * @type {Array<object>}
     * @memberof FilterCriteriaObject
     */
    'values'?: Array<object>;
}

export const FilterCriteriaObjectOperationEnum = {
    Custom: 'CUSTOM',
    Equal: 'EQUAL',
    NotEqual: 'NOT_EQUAL',
    Greater: 'GREATER',
    GreaterOrEqual: 'GREATER_OR_EQUAL',
    Less: 'LESS',
    LessOrEqual: 'LESS_OR_EQUAL',
    Like: 'LIKE',
    BeginsWith: 'BEGINS_WITH',
    EndsWith: 'ENDS_WITH',
    In: 'IN',
    NotIn: 'NOT_IN',
    IsNull: 'IS_NULL',
    IsNotNull: 'IS_NOT_NULL'
} as const;

export type FilterCriteriaObjectOperationEnum = typeof FilterCriteriaObjectOperationEnum[keyof typeof FilterCriteriaObjectOperationEnum];


